// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: "light",
  colors: {
    primary: "#dcdcdc",
    secondary: "#ffffff",
    tertiary: "#f5f5f5",

    white: "#000",
    black: "#fff",
    gray: "#bfbfbf",

    sucess: "#03bb85",
    info: "#3b5998",
    warning: "#ff6961",
  },
};
